import React, { useCallback, useRef } from "react"
import { IconButton, Stack } from "@mui/material"

import Image from "next/image"
import ArrowCarouselLeft from "@/assets/icons/arrow-carousel-left.svg"
import ArrowCarouselRight from "@/assets/icons/arrow-carousel-right.svg"

// Swiper
import { Swiper, SwiperRef, SwiperSlide } from "swiper/react"

import { Pagination, Navigation } from "swiper/modules"
import { AutoplayOptions } from "swiper/types"

function CardCarousel({
  id,
  items,
  xs,
  sm,
  md,
  autoplay,
}: {
  id: string
  items: any[]
  xs: number
  sm: number
  md: number
  autoplay?: boolean | AutoplayOptions | undefined
}) {
  const swiperRef = useRef<SwiperRef>(null)

  const handlePrev = useCallback(() => {
    if (swiperRef.current && swiperRef.current.swiper) swiperRef.current.swiper.slidePrev()
  }, [])

  const handleNext = useCallback(() => {
    if (swiperRef.current && swiperRef.current.swiper) swiperRef.current.swiper.slideNext()
  }, [])

  return (
    <Stack className='w-full' alignItems='center' gap={1.5}>
      <Swiper
        ref={swiperRef}
        wrapperClass='box-border'
        slidesPerView={1}
        spaceBetween={20}
        autoplay={autoplay}
        pagination={{
          clickable: true,
          el: `.${id}-swiper-pagination`,
        }}
        breakpoints={{
          600: {
            slidesPerView: xs,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: sm,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: md,
            spaceBetween: 20,
          },
        }}
        className={`${id}-swiper box-border w-full`}
        modules={[Pagination, Navigation]}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>{item}</SwiperSlide>
        ))}
      </Swiper>

      <Stack direction='row' className='bg-white p-1 rounded-full' alignItems='center' gap={0.5}>
        <IconButton className='bg-secondary p-0' onClick={handlePrev}>
          <Image alt='arrow-carousel-left' width={28} height={28} src={ArrowCarouselLeft} />
        </IconButton>
        <Stack direction='row' className={`${id}-swiper-pagination`} />
        <IconButton className='bg-secondary p-0' onClick={handleNext}>
          <Image alt='arrow-carousel-right' width={28} height={28} src={ArrowCarouselRight} />
        </IconButton>
      </Stack>
    </Stack>
  )
}

export default CardCarousel
